import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { EXPERIMENT_FOOTER_POSTS } from '../../constants/experiments';
import { connect } from '../../../common/components/runtime-context';
import FooterPostsMobile from './footer-posts-mobile';
import FooterPostsDesktop from './footer-posts-desktop';
import NoPosts from './no-posts';
import Loader from '../loader';
import { getIsFooterPostsEnabled } from '../../selectors/app-settings-selectors';
import { getFooterPosts } from '../../selectors/footer-posts-selectors';
import { getIsFooterPostsLoading } from '../../selectors/is-loading-selectors';
import withDeviceType from '../../hoc/with-device-type';
import withExperiment from '../../hoc/with-experiment';

const FooterPosts = ({
  isFooterPostsExperimentEnabled,
  isMobile,
  showEmptyState,
  posts,
  isLoading,
}) => {
  if (!isFooterPostsExperimentEnabled) {
    return null;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (posts.length === 0) {
    return showEmptyState ? <NoPosts /> : null;
  }

  return isMobile ? <FooterPostsMobile posts={posts} /> : <FooterPostsDesktop posts={posts} />;
};

FooterPosts.propTypes = {
  isFooterPostsExperimentEnabled: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  showEmptyState: PropTypes.bool.isRequired,
  posts: PropTypes.array,
};

FooterPosts.defaultProps = {
  showEmptyState: false,
};

const mapRuntimeToProps = state => ({
  isFooterPostsSettingsEnabled: getIsFooterPostsEnabled(state),
  isLoading: getIsFooterPostsLoading(state),
  posts: getFooterPosts(state),
});

export default flowRight(
  withDeviceType,
  withExperiment({ isFooterPostsExperimentEnabled: EXPERIMENT_FOOTER_POSTS }),
  connect(mapRuntimeToProps),
)(FooterPosts);
